import styled from "styled-components"
export const WrapperReg = styled.div`
    width: 100%;
    .sc-kstqJO.hVfkeN{
        padding: 9px 5px !important;
        /* background-color:red; */
    }
`
